<template>
	<div class="filters carGate">
		<!-- <el-card class="cardSearch"> -->
		<el-form ref="form" :model="form" :rules="rules" class="cardSearch wid100"
			:label-width="require('@/config/enum').c_w9" :label-suffix="require('@/config/enum').c_colon">
			<!-- 车场 -->
			<el-form-item :label="$t('lang.lab_selPark')" prop="parkId">
				<el-select v-model="form.parkId">
					<el-option v-for="(item,index) in parkList" :key="index" :label="item.parkName" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<!-- 车牌号 -->
			<el-form-item :label="$t('lang.lab_carNumber')" prop="carNumber">
				<el-select class="citySelect" v-model="cityValue">
					<el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-input v-model="form.carNumber" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_carNumber')"
					class="item-input"></el-input>
			</el-form-item>
			<el-button @click="selPark">{{$t('lang.btn_selVote')}}</el-button>
			<el-link type="primary" @click.native="add2">月租车临期查询</el-link>
			<!-- 车场出入口 -->
			<el-card class="cardTree" v-show="cardTreeShow">
				<el-tree class="filter-tree" :data="treeData" :props="defaultProps" ref="tree" node-key="Id" show-checkbox
					@node-click="treeHandleClick" :default-checked-keys="gateList" default-expand-all highlight-current
					:expand-on-click-node="false"></el-tree>
			</el-card>
		</el-form>
		<!-- 时间 -->
		<el-form v-if="(carType === 1 || carType === 3)" ref="dateForm" :model="dateForm" :rules="dateRules" class="cardSearch wid100"
			:label-width="require('@/config/enum').c_w9" :label-suffix="require('@/config/enum').c_colon">
			<!-- <el-form-item :label="$t('lang.lab_InOutTime')" prop="dateValue">
				<el-date-picker v-model="dateForm.dateValue" type="daterange" :range-separator="$t('lang.reportGo')"
					:start-placeholder="$t('lang.lab_startTime')" :end-placeholder="$t('lang.lab_endTime')"
					:default-time="['00:00:00', '23:59:59']" value-format="timestamp" unlink-panels>
				</el-date-picker>
			</el-form-item> -->
			<el-form-item label="开始日期" prop="startDate">
				<el-date-picker :disabled="startDateDisabled" v-model="dateForm.startDate" type="date" placeholder="选择开始日期"></el-date-picker>
			</el-form-item>
			<el-form-item label="截止日期" prop="endDate">
				<el-date-picker v-model="dateForm.endDate" type="date" placeholder="选择截止日期"></el-date-picker>
			</el-form-item>
			<el-form-item label="车辆类型" v-if="carType === 1">月租车</el-form-item>
			<el-form-item label="车辆类型" v-if="carType === 3">固定车</el-form-item>
			<el-button @click="add" :disabled='isDisabled'>{{$t('lang.btn_save')}}</el-button>
		</el-form>
		<el-form v-if="carType === 2" ref="dateForm" :model="dateForm" :rules="dateRules" class="cardSearch wid100"
			:label-width="require('@/config/enum').c_w9" :label-suffix="require('@/config/enum').c_colon">
			<el-form-item label="车辆类型">储值车</el-form-item>
			<el-button @click="add1" :disabled='isDisabled'>{{$t('lang.btn_save')}}</el-button>
		</el-form>
		<!-- </el-card> -->
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				carId: '',
				carType: 0,
				/* tree数据 */
				treeData: [],
				/* tree子数据结构 */
				defaultProps: {
					children: 'children',
					label: 'Name',
				},
				parkList: [],
				gateList: [],
				form: {
					carNumber: 'A',
					newCarNum: '',
					parkId: ''
				},
				dateForm: {
					// dateValue: [], // 时间数组
					startDate: new Date().getTime(), // 开始日期
					endDate: '', // 开始日期
				},
				isDisabled: true, // 保存按钮disabled状态
				cardTreeShow: false, // tree显示状态
				rules: {
					carNumber: [{
						required: true,
						message: this.$i18n.t('lang.lab_pleCarNum'),
						trigger: 'blur'
					}],
					parkId: [{
						required: true,
						message: this.$i18n.t('lang.lab_pleCarPark'),
						trigger: 'change'
					}]
				},
				dateRules: {
					// dateValue: [{
					// 	required: true,
					// 	message: this.$i18n.t('lang.lab_pleInOutTime'),
					// 	trigger: 'blur'
					// }],
					startDate: [{
						required: true,
						message: '请选择开始日期',
						trigger: 'change'
					}],
					endDate: [{
						required: true,
						message: '请选择截止日期',
						trigger: 'change'
					}]
				},
				cityList: [{
						value: '辽',
						label: '辽'
					},
					{
						value: '吉',
						label: '吉'
					},
					{
						value: '黑',
						label: '黑'
					},
					{
						value: '蒙',
						label: '蒙'
					},
					{
						value: '京',
						label: '京'
					},
					{
						value: '津',
						label: '津'
					},
					{
						value: '冀',
						label: '冀'
					},
					{
						value: '沪',
						label: '沪'
					},
					{
						value: '渝',
						label: '渝'
					},
					{
						value: '豫',
						label: '豫'
					},
					{
						value: '云',
						label: '云'
					},
					{
						value: '湘',
						label: '湘'
					},
					{
						value: '鲁',
						label: '鲁'
					},
					{
						value: '新',
						label: '新'
					},
					{
						value: '苏',
						label: '苏'
					},
					{
						value: '浙',
						label: '浙'
					},
					{
						value: '赣',
						label: '赣'
					},
					{
						value: '鄂',
						label: '鄂'
					},
					{
						value: '桂',
						label: '桂'
					},
					{
						value: '甘',
						label: '甘'
					},
					{
						value: '晋',
						label: '晋'
					},
					{
						value: '陕',
						label: '陕'
					},
					{
						value: '皖',
						label: '皖'
					},
					{
						value: '闽',
						label: '闽'
					},
					{
						value: '贵',
						label: '贵'
					},
					{
						value: '青',
						label: '青'
					},
					{
						value: '粤',
						label: '粤'
					},
					{
						value: '藏',
						label: '藏'
					},
					{
						value: '川',
						label: '川'
					},
					{
						value: '宁',
						label: '宁'
					},
					{
						value: '琼',
						label: '琼'
					},
					{
						value: '使',
						label: '使'
					},
					{
						value: '领',
						label: '领'
					},
					{
						value: '电',
						label: '电'
					},
				], // 城市列表
				cityValue: '云', // 选择的城市值
				startDateDisabled: false, // 开始日期只读状态
			}
		},
		computed: {
			carNumber() {
				return this.form.carNumber
			},
			parkId() {
				return this.form.parkId
			},
			...mapGetters(['gardenId'])
		},
		watch: {
			carNumber() {
				this.isDisabled = true
			},
			parkId() {
				this.isDisabled = true
			},
			cityValue(newVal, oldVal) {
				if (newVal == '电') {
					this.form.carNumber = 'D'
				}
			}
		},
		mounted() {
			this.getParkList()
		},
		methods: {
			/* 获取车场列表 */
			getParkList() {
				let loading = this.$loading()
				this.$get(`carPark?pageNo=1&pageSize=99&gardenId=${this.gardenId}`)
					.then(res => {
							loading.close()
							this.parkList = res.list
							if (res.list.length > 0) {
								this.form.parkId = res.list[0].id
							}
						},
						err => {
							loading.close()
							this.$message.error(err)
						})
			},
			/* 获取节点数据 */
			treeHandleClick(data) {
				console.log(data)
			},

			/* 查询车场列表 */
			selPark() {
				this.treeData = []
				this.gateList = []
				const reg =
					/^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[a-zA-Z](([DABCEFGHJK]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DABCEFGHJK]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
				this.form.newCarNum = this.cityValue + this.form.carNumber
				if (this.form.carNumber != '' && !reg.test(this.form.newCarNum)) {
					this.$alert(this.$i18n.t('lang.lab_pleRightCarNum'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						type: 'warning'
					})
					this.treeData = []
					this.cardTreeShow = false
				} else {
					this.treeData = []
					this.$refs.form.validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							this.cardTreeShow = true
							/* 出入口树形结构 */
							this.$get(`CarGateRule/selectAllList`, {
									gardenId: this.gardenId,
									parkId: this.form.parkId
								})
								.then(res => {
										console.log(res)
										loading.close()
										this.treeData = res.list
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
							/* 查询车辆信息 */
							this.$get(`carNumInfo`, {
									parkId: this.form.parkId,
									carNum: this.form.newCarNum
								})
								.then(res => {
										loading.close()
										this.gateList = res.gateList
										if (res.carNumInfo != null && res.carNumInfo.id > 0) {
											// this.dateForm.dateValue = []
											this.dateForm.startDate = new Date().getTime()
											this.dateForm.endDate = ''
											this.isDisabled = false
											this.carId = res.carNumInfo.id
											this.carType = res.carNumInfo.carType
											var startDate = res.carNumInfo.startDate
											var endDate = res.carNumInfo.endDate
											if (startDate != null) {
												// this.dateForm.dateValue.push(startDate)
												// this.dateForm.dateValue.push(endDate)
												this.dateForm.startDate = startDate
												this.dateForm.endDate = endDate
												this.startDateDisabled = true
											} else {
												this.startDateDisabled = false
											}

											// console.log(this.dateForm.dateValue)
											console.log(this.dateForm.startDate)
											console.log(this.dateForm.endDate)
										} else {
											this.$message.error('车牌号不存在')
											// this.dateForm.dateValue = []
											this.dateForm.startDate = new Date().getTime()
											this.dateForm.endDate = ''
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
						}
					})
				}
			},
			/* 添加 */
			add() {
				const reg =
					/^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[a-zA-Z](([DABCEFGHJK]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DABCEFGHJK]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
				if (!reg.test(this.form.newCarNum)) {
					this.$alert(this.$i18n.t('lang.lab_pleRightCarNum'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						type: 'warning'
					})
				} else {
					this.$refs.form.validate((valid) => {
						if (valid) {
							this.$refs.dateForm.validate((valid) => {
								if (valid) {
									this.isDisabled = true
									let loading = this.$loading()
									this.$post(`carGateRule`, {
										carId: this.carId,
										parkId: this.form.parkId,
										gardenId: this.gardenId,
										'gateIds[]': this.$refs.tree.getCheckedKeys(true).toString()
									}).then(
										res => {
											loading.close()
											// var sd = new Date(this.dateForm.dateValue[0])
											// var ed = new Date(this.dateForm.dateValue[1])
											var sd = new Date(this.dateForm.startDate)
											var ed = new Date(this.dateForm.endDate)
											var now = new Date()

											if (sd > now) {
												this.$confirm('开始时间晚于当前时间，是否继续？').then(_ => {
													this.$patch(`carNumById/` + this.carId, {
														startTime: sd.getTime(sd),
														endTime: ed.getTime(ed)
													}).then(
														res => {
															loading.close()															
															this.isDisabled = false
															// this.$message.success(this.$i18n.t('lang.lab_save_success'))
															this.$alert('保存成功', '提示', {
																confirmButtonText: '确定',
																callback: action => {}
															})
															// eslint-disable-next-line no-unused-expressions
															err => {
																loading.close()
																this.$message.error(err)
															}
														})
												}).catch(_ => {})
											} else {
												this.$patch(`carNumById/` + this.carId, {
													startTime: sd.getTime(sd),
													endTime: ed.getTime(ed)
												}).then(
													res => {
														loading.close()														
														this.isDisabled = false
														// this.$message.success(this.$i18n.t('lang.lab_save_success'))
														this.$alert('保存成功', '提示', {
															confirmButtonText: '确定',
															callback: action => {}
														})
														// eslint-disable-next-line no-unused-expressions
														err => {
															loading.close()
															this.$message.error(err)
														}
													})
											}
										},
										err => {
											loading.close()
											this.$message.error(err)
										}
									)
								}
							})
						}
					})
				}
			},
			add1() {
				const reg =
					/^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[a-zA-Z](([DABCEFGHJK]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DABCEFGHJK]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
				if (!reg.test(this.form.newCarNum)) {
					this.$alert(this.$i18n.t('lang.lab_pleRightCarNum'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						type: 'warning'
					})
				} else {
					this.$refs.form.validate((valid) => {
						if (valid) {
							this.$refs.dateForm.validate((valid) => {
								if (valid) {
									this.isDisabled = true
									let loading = this.$loading()
									this.$post(`carGateRule`, {
										carId: this.carId,
										parkId: this.form.parkId,
										gardenId: this.gardenId,
										'gateIds[]': this.$refs.tree.getCheckedKeys(true).toString()
									}).then(
										res => {
											loading.close()
											this.isDisabled = false
											// this.$message.success(this.$i18n.t('lang.lab_save_success'))
											this.$alert('保存成功', '提示', {
												confirmButtonText: '确定',
												callback: action => {}
											})
										},
										err => {
											loading.close()
											this.$message.error(err)
										}
									)
								}
							})
						}
					})
				}
			},
			add2() {
				if (this.form.parkId != '') {
					this.$router.push({
						name: 'carEndDateList',
						query: {
							parkId: this.form.parkId
						}
					})
				} else {
					this.$message.error('请选择车场')
				}
			},
		}
	}
</script>

<style lang="scss">
	.carGate .el-select,
	.carGate .el-input {
		width: 320px;
	}
	.carGate .el-date-editor,.carGate .el-date-editor .el-input__inner {
		width: 320px!important;
	}

	.carGate .el-input__validateIcon{
		display: none!important;
	}

	.carGate .el-form-item {
		margin: 20px;
	}

	.carGate .el-button {
		margin-left: 180px;
	}

	.carGate .cardTree {
		width: 300px;
		margin: 20px 0 30px 180px;
	}

	.carGate .el-tree-node__label {
		margin-left: 5px;
	}

	.carGate .citySelect {
		width: 70px !important;
		margin-right: 5px !important;
	}

	.carGate .citySelect .el-input {
		width: 70px !important;
	}
</style>